import useTimeZoneClock from 'hooks/useTimeZoneClock';
import React from 'react'
import { Table } from 'reactstrap'

const LogsTable = ({ logs }) => {
    // const formattedDate = moment(timeZone).format('MMMM DD YYYY, hh:mm A');
    const renderTableHeader = React.useCallback(() => {

        return (
            <tr>
                <th className="col-1">
                    <span>Date</span>
                </th>
                <th className="col-1">
                    Time
                </th>
                <th className="col-3">
                    Event
                </th>
                <th className="col-2">
                    User
                </th>
                <th className="col-5">
                    Notes
                </th>
            </tr>
        )
    }, [])


    const renderTableContent = React.useCallback((item) => {
        return (
            <LogItem item={item} key={item?.id} />
        )
    }, []);

    return (
        <div className='table_responsive'>
            <table className="table">
                <thead className="text-primary">
                    {renderTableHeader()}
                </thead>
                <tbody>
                    {
                        logs && logs?.map(item => renderTableContent(item))
                    }
                </tbody>
            </table>
        </div>
    )
}

const LogItem = ({ item }) => {



    // const timeZone = useTimeZoneClock(item?.datetime);

    return (

        <tr>
            <td className='col-2'>
                {item?.date}
            </td>
            <td className='col-2'>
                {item?.time}
            </td>
            <td className='col-2'>
                {item?.event}
            </td>
            <td className='col-2'>
                {item?.user?.name}
            </td>
            <td className='col-4'>
                {item?.notes}
            </td>
        </tr>
    )
}
export default LogsTable